import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import ComputerIcn from 'views/ui/icons/computer';
import { Theme } from 'ui_system/theme';
import { toggleShowResourceMeetingModal } from 'data_system/resource_portal/actions/resourceActions';
import { getLinkColor } from 'data_system/resource_portal/selectors';
import {
  FieldSection,
  AddButton as AddButtn,
  SubLabel,
  Label,
  Text,
  Error,
} from 'ui_system/forms/FormStyles';
import { lowercase } from 'lib/string_utils';
import { PlusSign as PlusSgn } from '../../ExperienceList';

const OnlineLocation = styled.div`
  height: 44px;
  width: 100%;
  border: 1px solid ${Theme.colors.inputs.border};
`;

const PlusSign = styled(PlusSgn)`
  color: ${(props) => props.color || Theme.colors.green};
`;

const AddButton = styled(AddButtn)`
  margin-top: 30px;
  min-width: 85px;
  width: 85px;
  font-size: 16px;
`;

const ComputerIcon = styled(ComputerIcn)`
  fill: ${Theme.colors.inputs.placeholder};
  width: 20px;
  margin: 10px 8px;
`;

const OnlineExperienceText = styled.span`
  display: block;
  margin-top: -31px;
  margin-left: 36px;
`;

const MeetingInfo = styled.div`
  background: ${Theme.colors.lightBackground};
  padding: 16px 14px;
  width: 100%;
  margin-bottom: 10px;
`;

const List = styled.div`
  display: grid;
  line-height: 18px;
  row-gap: 10px;
  column-gap: 30px;
  margin-top: 10px;
  grid-template-columns: 1fr;
  @media (min-width: ${Theme.mobile.phoneWidth}px) {
    grid-template-columns: 1fr 3fr;
  }
`;

const WrapText = styled.div`
  text-transform: none;
  overflow-wrap: break-word;
  margin-bottom: ${(props) => (props.marginBottom ? '20px' : '0px')};
  font-weight: 600;
  width: 86vw;
  @media (min-width: ${Theme.mobile.phoneWidth}px) {
    max-width: 320px;
    margin-bottom: 0px;
  }
`;

const OnlineDetailEdit = styled.div`
  cursor: pointer;
  color: ${(props) => props.theme.brandColor || Theme.colors.green};
  float: right;
`;

const OnlineExperienceDetail = ({
  t,
  meetingInformation: {
    id,
    vendorMeetingUrl,
    vendorMeetingId,
    vendorMeetingPassword,
  },
  error,
}) => {
  const dispatch = useDispatch();
  const linkColor = useSelector(getLinkColor);
  return (
    <React.Fragment>
      <FieldSection>
        <Label>{lowercase(t('LOCATION'))}</Label>
        <SubLabel>{t('THIS_IS_AN_ONLINE_CLASS')}</SubLabel>
        <OnlineLocation>
          <ComputerIcon />
          <OnlineExperienceText>{t('ONLINE')}</OnlineExperienceText>
        </OnlineLocation>
      </FieldSection>
      <FieldSection>
        <MeetingInfo>
          <Label>{t('VIDEO_CONFERENCING_DETAILS')}</Label>
          {id && (
            <OnlineDetailEdit
              onClick={() => dispatch(toggleShowResourceMeetingModal(true))}
            >
              {t('EDIT')}
            </OnlineDetailEdit>
          )}
          {vendorMeetingUrl ? (
            <List>
              <Text small>URL to Connect</Text>
              <WrapText marginBottom={vendorMeetingId || vendorMeetingPassword}>
                &#8203;{vendorMeetingUrl}
              </WrapText>
              {vendorMeetingId && <Text small>Meeting ID</Text>}
              {vendorMeetingId && (
                <WrapText marginBottom={vendorMeetingPassword}>
                  &#8203;{vendorMeetingId}
                </WrapText>
              )}
              {vendorMeetingPassword && <Text small>Password</Text>}
              {vendorMeetingPassword && (
                <WrapText>&#8203;{vendorMeetingPassword}</WrapText>
              )}
            </List>
          ) : (
            <AddButton
              color={linkColor}
              onClick={() => dispatch(toggleShowResourceMeetingModal(true))}
            >
              <PlusSign color={linkColor}>&#x2b;</PlusSign> Add
            </AddButton>
          )}
        </MeetingInfo>
        {error && <Error noMargin>{error}</Error>}
      </FieldSection>
    </React.Fragment>
  );
};

export default OnlineExperienceDetail;
